import {Http} from '@/model/Http.js'

export default class pay extends Http {
  getList(data) {
    const url = '/open/open/refund-config/list'
    return this.postAjaxByMini(url, data)
  }
  
  save(data) {
    const url = '/open/open/refund-config/save-or-update'
    return this.postAjaxByMiniNew(url, data)
  }
  
  delete(data) {
    const url = '/open/open/refund-config/delete'
    return this.postAjaxByMini(url, data)
  }
  
  switch(data) {
    const url = '/open/open/refund-config/update-status'
    return this.postAjaxByMini(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/api/quick-set.js